import React from 'react'
import { Helmet } from 'react-helmet'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import banner from '../assets/images/UrgentCare/banner.png'
import banner_mb from '../assets/images/UrgentCare/banner_mb.png'
import BelowBanner from '../components/common/BelowBanner'
import Section1 from '../components/common/Section1'
import Section2 from '../components/common/Section2'
import ServicesListSection from '../components/common/ServicesListSection'
import MiddleBanner from '../components/common/MiddleBanner'
import { Link } from 'react-router-dom'

const ParagraphText = () => {
    return (
        <>
            <p className='text-justify'>When you or your child suffers from an injury or gets sick, getting urgent care from your doctor is vital. Muhammad Ata, MD, and the team at <Link to="https://www.premiermdclinic.com/" target="_self" className='text-decoration-none text-zk-primary' rel="noopener noreferrer">Premier Medical Clinic</Link> in Scottsboro, Alabama, provide easy access to people of all ages at their urgent care clinics on Saturdays from 9 am to 12 pm. To find out more about urgent care services, call Premier Medical Clinic today. You can also book appointments online.
            </p>
        </>
    )
} 
const ParagraphText1 = () => {
    return (
        <>
            <p className='text-justify'>The treatment you need at your urgent care consultation depends on the reason for your visit. If you have a bacterial infection, your urgent care provider might give you antibiotics. Viral infections don’t respond to these drugs, though. The best thing to do is look after yourself or your child until the immune system fights off the infection. Premier Medical Clinic urgent care providers can also clean and stitch wounds, set minor fractures, and dress burns and scalds. They prescribe medicines for allergic reactions and <Link to="https://www.premiermdclinic.com/skin-cancer" target="_self" className='text-decoration-none text-zk-primary' rel="noopener noreferrer">skin conditions</Link>, increase the fluid levels in your body for rehydration, and offer splints or other supportive devices for sprains and strains. If you or anyone in your family suffers an injury or becomes sick enough to need medical attention, visit Premier Medical Clinic’s urgent care services. You can find out more by calling the office today or booking an appointment online.
            </p>
        </>
    )
}

const UrgentCare = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>Trusted Scottsboro Urgent Care: Skilled Physicians at Your Service</title>
                <meta name="description" content="Looking for reliable urgent care in Scottsboro? Our experienced physicians provide prompt and high-quality medical services for all your urgent needs." />
                <link rel="canonical" href="https://premiermdclinic.com/urgent-care" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Trusted Scottsboro Urgent Care: Skilled Physicians at Your Service" />
                <meta property="og:description" content="Looking for reliable urgent care in Scottsboro? Our experienced physicians provide prompt and high-quality medical services for all your urgent needs." />
                <meta property="og:url" content="https://premiermdclinic.com/urgent-care"/>
                <meta property="og:site_name" content="Premier Medical Clinic" />
                <meta property="og:image" content="https://premiermdclinic.com/pmc-og.png" />
                <meta property='og:image:width' content='1200' />
                <meta property='og:image:height' content='630' />
                <meta property="og:image:secure_url" content="https://premiermdclinic.com/pmc-og.png" />
                <meta property="og:image:type" content="image/png" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Trusted Scottsboro Urgent Care: Skilled Physicians at Your Service" />
                <meta name="twitter:description" content="Looking for reliable urgent care in Scottsboro? Our experienced physicians provide prompt and high-quality medical services for all your urgent needs." />
                <meta name="twitter:image" content="https://premiermdclinic.com/pmc-og.png" />
            </Helmet>
            <Header />
            <section>
                <div className='banner-section'>
                    <img className="img-fluid d-none d-sm-none d-md-block" alt='Urgent Care' src={banner} style={{ minWidth:"100%"}}/>
                    <img className="img-fluid d-md-none d-sm-block" alt='Urgent Care' src={banner_mb} style={{ minWidth:"100%"}}/>
                    <div className='container-zk'>
                        <div className='page-banner-content'>
                            <div className='text-transform-capitalize text-oswald text-zk-secondary page-banner-title'>Urgent Care</div>
                        </div>
                    </div>
                </div>
            </section>
            <div id="website-responsive">
                <section className='my-4'>
                    <BelowBanner Title="Trusted Scottsboro Urgent Care: Skilled Physicians at Your Service" Para={<ParagraphText/>}/>
                </section>
            
                <section>
                        <Section1 SubTitle="What is urgent care?" Para="
                        Urgent care is a service that promptly treats individuals dealing with sudden illness or injury, offering immediate medical attention for both adults and children. Premier Medical Clinic provides this urgent care on a walk-in basis without requiring prior appointments. Moreover, we have on-site X-ray facilities to address minor injuries and offer swift testing for conditions like COVID-19 and strep throat." bgClass="bg-urgentcare-section1" />
                    </section>
                    <section>
                        <ServicesListSection 
                        Title="Comprehensive Urgent Care Services in Scottsboro" 
                        Paragraph1="The urgent care providers at Premier Medical Clinic can diagnose and treat virtually any illness or injury that requires swift attention. Conditions their urgent care providers treat most often include" 
                        Paragraph2="Many of these conditions aren’t usually life-threatening but could all benefit from urgent care." 
                        ListItems={[
                            "Fevers",
                            "Colds and flu",
                            "Strep throat and tonsillitis",
                            "Upset stomach",
                            "Rashes and hives",
                            "Ear and eye infections",
                            "Headaches and migraines",
                            "Sprains and strains",
                            "Back and neck injuries",
                            "Cuts, scalds, and burns",
                            "Vomiting and diarrhea",
                            "Urinary tract infection (UTI)"
                        ]} />
                    </section>
                    <section>
                        <MiddleBanner/>
                    </section>
                    <section>
                        <ServicesListSection 
                        Title="Should I visit an urgent care clinic or the hospital emergency room?" 
                        Paragraph1="Going to Premier Medical Clinic for your urgent care is far less stressful and more convenient than visiting the hospital emergency room (ER). It’s also more pleasant being in a familiar place with people you know when you’re sick. However, sometimes you need to go straight to the emergency room. Problems that you should consider emergencies include:" 
                        Paragraph2="Hospital care is also best for babies under three months old with a fever of 100.4°F or above." 
                        ListItems={[
                            "Loss of consciousness",
                            "Seizures",
                            "Moderate-to-severe burns",
                            "Severe head or spinal injuries",
                            "Severe back, abdominal, or chest pain",
                            "Difficulty breathing",
                            "Suddenly being unable to speak, walk, or move",
                            "Compound fractures (where the bone is visible)"
                        ]} />
                    </section>
                    <section className='mb-md-5'>
                    <Section2 SubTitle="Why urgent care treatment you might need?" Paragraph={<ParagraphText1/>} bgClass="bg-urgentcare-section2" />
                    </section>
            </div>

            <Footer/>

        </React.Fragment>
    )
}

export default UrgentCare